import axios from 'axios';
import logger from '../utils/logger';

// Create axios instance with base URL
// In development: point to localhost:5000/api
// In staging/production: point to /api (relative) so it goes through the Vercel proxy
const getApiBaseUrl = () => {
  // If we're in development (localhost), use the full localhost URL
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api';
  }
  
  // In staging/production, use relative /api path to go through Vercel proxy
  return '/api';
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  // Align with Vercel/proxy maxDuration (60s); old 10s matched legacy platform limit
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor to add auth token if available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  // Minimal debug via logger (filtered in production/staging)
  logger.api('API request', {
    url: config.url,
    method: config.method,
    baseURL: config.baseURL,
    hasToken: !!token
  });
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    logger.debug('Authorization header attached');
  }
  return config;
});

export { api }; 